// extracted by mini-css-extract-plugin
module.exports = {"rate":"style_rate__1B_lG","appraisal":"style_appraisal__2PNYP","star":"style_star__D4Bza"};